// import {Decorators, EnumTypeRegistry, Formatter} from "@serenity-is/corelib";
// import {FormatterContext, FormatterResult} from "@serenity-is/sleekgrid";
// import {enumMapperMap, invokeNamedFunction} from "@/Csi";
// namespace GeniuzPOS.Common {
// @Serenity.Decorators.registerFormatter("Csi.Formatters.StringValueEnumFormatter")
// export class StringValueEnumFormatter implements Formatter {

//     @Serenity.Decorators.option()
//     public EnumKey: string;

//     @Serenity.Decorators.option()
//     public EnumType: string;

//     private enumObj: any;

//     format(ctx: Serenity.FormatterContext<any>): FormatterResult {
//         const src = ctx.value as string;
//         if (!src) return '';

//         if (!this.EnumKey) return src;

//         if (!this.enumObj) {
//             this.enumObj = EnumTypeRegistry.get(this.EnumKey);
//         }

//         if (!this.EnumType) {
//             return src;
//         }

//         const v = invokeNamedFunction(this.EnumType as keyof typeof enumMapperMap, src);
//         return Object.values(this.enumObj)[v].toString().split(/(?=[A-Z])/).join(" ").trim();
//     }
// }
// }

namespace GeniuzPOS.Common {
@Serenity.Decorators.registerFormatter()
export class StringValueEnumFormatter implements Slick.Formatter {
    constructor() {
        this.allowClear = true;
    }

    format(ctx: Slick.FormatterContext) {
        var enumType = Serenity.EnumTypeRegistry.get(this.enumKey);

        var sb = "<select>";
        if (this.allowClear) {
            sb += '<option value="">';
            sb += Q.htmlEncode(this.emptyItemText || Q.text("Controls.SelectEditor.EmptyItemText"));
            sb += '</option>';
        }

        for (var x of Object.keys(enumType).filter(v => !isNaN(parseInt(v, 10)))) {
            sb += '<option value="' + Q.attrEncode(x) + '"';
            if (x == ctx.value)
                sb += " selected";
            var name = enumType[x];
            sb += ">";
            sb += Q.htmlEncode(Q.tryGetText("Enums." + this.enumKey + "." + name) || name);
            sb += "</option>";
        }

        sb += "</select>";

        return sb;
    }

    @Serenity.Decorators.option()
    public enumKey: string;

    @Serenity.Decorators.option()
    public allowClear: boolean;

    @Serenity.Decorators.option()
    public emptyItemText: string;
}}